<div class="flex flex-col gap-3 w-full py-4  md:border-top bg-white">
    <!-- Ttile -->
    <div class="w-full">
        <h2 class="text-xl text-black font-bold">اتاق‌ها و سرویس بهداشتی</h2>
    </div>
    <div class="w-full" id="slider-restrooms">
        <ng-container *ngIf="resetSwiper()">
            <swiper [config]="configSwiperComments">
        
                <ng-template swiperSlide *ngFor="let item of dataRestrooms">
        
                    <div class=" p-3 border border-solid rounded-xl h-[130px] w-[150px]">
                        <div class="w-full mt-4">
        
                            <p class="text-base text-black-500 font-bold">
                              {{item?.title}}
                            </p>
                            <p class="text-sm text-black-300"> {{item?.description}}</p>
        
                        </div>
                       
                    </div>
        
                </ng-template>
            </swiper>
        </ng-container>
    </div>
</div>